module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("自助缴费")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.shjf()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shenghuojiaofei-item"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("生活缴费")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("水、电、煤等在线缴费")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.zhxy()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-zhihuixiaoyuan-item"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("智慧校园")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("长沙银行代收学费")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c964de5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment_dialog/payment_dialog.vue
// module id = 316
// module chunks = 40